/* eslint-disable no-unused-vars */
import React from 'react';
import {Image, Title} from './../../Basics';
import Particle from './../../Particle';
/* eslint-enable no-unused-vars */

const Particle23 = () => (<div>

  <Title>Das waren die Sieger</Title>

  <Image
    source={require('./23_Bild_4_WHEEL_Team_HSR-Enhanced_AlessandroDellaBella_115.jpg')}
    title='Sieger Rollstuhl-Parcours'
    caption={
      <span>
      <b>Rollstuhl-Parcours</b>
      Pilot Florian Hauser (rechts), HSR Enhanced, Schweiz mit Projektleiter Christian Bermes
      </span>
    }
  />

  <Particle
    number={27}
  />

  <Image
    source={require('./23_Bild_1_ARM_Gold-Medal_Team-DIPO-Power_AlessandroDellaBella_095.jpg')}
    title='Sieger Armprothesen-Parcours'
    caption={
      <span>
      <b>Armprothesen-Parcours</b>
      Goldmedaille: Robert Radocy (zweiter v.r.), Team DIPO Power, Niederlande
      <b/>
      Silbermedaille: Patrick Mayrhofer (zweiter v.l.), Team Michelangelo, Deutschland
      </span>
    }
  />

  <Image
    source={require('./23_Bild_2_LEG_Team_OssurRheoKnee_NicolaPitaro_7953.jpg')}
    title='Sieger Beinprothesen-Parcours'
    caption={
      <span>
      <b>Beinprothesen-Parcours</b>
      Helgi Sveinsson, Team RHEO KNEE, Island
      </span>
    }
  />

  <Image
    source={require('./23_Bild_3_BCI_Team_Brain-Tweakers_NicolaPitaro_7881.jpg')}
    title='Sieger Virtuelles Rennen mit Gedankensteuerung'
    caption={
      <span>
      <b>Virtuelles Rennen mit Gedankensteuerung</b>
      Numa Poujouly, Team Brain Tweakers, Schweiz
      </span>
    }
  />

  <Image
    source={require('./23_Bild_5_EXO_Team_ReWalk_NicolaPitaro_7012.jpg')}
    title='Sieger Exoskelett-Parcours'
    caption={
      <span>
      <b>Exoskelett-Parcours</b>
      André Van Rüschen (Mitte) mit dem Team ReWalk, Deutschland
      </span>
    }
  />

  <Image
    source={require('./23_Bild_6_FES_Team-Cleveland_NicolaPitaro_8098.jpg')}
    title='Sieger Velorennen mit Muskelstimulation'
    caption={
      <span>
      <b>Fahrradrennen mit Muskelstimulation</b>
      Mark Muhn, Team Cleveland, USA
      <br/>
      Fotos: ETHZ
      </span>
    }
  />

<Particle
number={2}
/>


</div>);

export default Particle23;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle23/Particle23.js
 **/